/**
 * RippleCircle.js
 * Circle for touch ripple animation
 *
 * @class  RippleCircle
 * @author Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import PropsJoin from '../../../mixins/js/PropsJoin';

export default React.createClass({
	
	displayName: "RippleCircle",

	mixins: [ PropsJoin ],

	propTypes: {
		className: React.PropTypes.string,
		started: React.PropTypes.bool,
		ending: React.PropTypes.bool
	},

	render() {

		let innerClassName = this.props.innerClassName,
			started = this.props.started,
			ending = this.props.ending,
			other = this.joinProps(this.props, {
				innerClassName: 1,
				started: 1,
				ending: 1
			});

		let classes = ClassNames('lui-ripple-circle', {
			'lui-is-started': this.props.started,
			'lui-is-ending': this.props.ending
		});

		return (
			React.createElement("div", React.__spread({}, other, {
					className: classes
				}),
				React.createElement("div", {
					className: "lui-ripple-circle-inner"
				})
			)
		);
	}
});



/** WEBPACK FOOTER **
 ** ./src/components/animations/ripple-circle/RippleCircle.js
 **/